// Read-only view of a project's GIS Upload Instructions, as written by the
// office in BLVD Field. The portal only shows this text — it is never edited
// here and never interpreted. React escapes it on render.
export default function InstructionsModal({ title, subtitle, text, updatedAt, onClose }) {
  const updated = updatedAt ? new Date(updatedAt) : null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-lg rounded-xl border border-navy-500 p-6" style={{ backgroundColor: '#142236' }}>
        <div className="flex items-start justify-between mb-3">
          <div>
            <h2 className="text-white font-bold text-lg">📋 GIS Upload Instructions</h2>
            <p className="text-gray-400 text-xs mt-0.5 font-mono">{title}{subtitle ? ` — ${subtitle}` : ''}</p>
          </div>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition text-xl leading-none">&times;</button>
        </div>

        <div
          className="rounded px-3 py-2 text-sm text-gray-100 whitespace-pre-wrap break-words min-h-[120px] border border-amber-500/40"
          style={{ backgroundColor: '#0f1a29' }}
        >
          {text}
        </div>

        <p className="text-[11px] text-gray-500 mt-2">
          Written in BLVD Field
          {updated && !Number.isNaN(updated.getTime()) ? ` · updated ${updated.toLocaleString()}` : ''}
          . Read-only here — it can change after you read it, and completing the job below stamps GIS Data Upload in Site Tracker as usual.
        </p>

        <div className="flex gap-3 mt-4">
          <button onClick={onClose} className="flex-1 py-2 rounded border border-navy-500 text-gray-300 text-sm hover:text-white hover:border-gray-400 transition">Close</button>
        </div>
      </div>
    </div>
  );
}
